import * as actionTypes from './actionTypes';

export const updateMemberBalance=(data)=>{
   return {
      type:actionTypes.UPDATE_MEMBER_BALANCE,
      payload:data
   }
}